module.exports = __webpack_public_path__ + "img/1 6-0.7ddffb9b.png";